import React, { useEffect } from 'react';
import '../../../style/jobPostings.scss';
import { Header } from '../../../components/Header';
import { Partners } from '../../../components/home/partners';
import { OpportunitiesList } from './OpportunitiesList';
import { useLocation } from 'react-router-dom';
import { Divider } from '@mui/material';

const OpportunititesInterships = ({ allPostingsLimit, ...props }) => {
  const location = useLocation();
  // useEffect(() => {
  //   document.documentElement.scrollTo({
  //     top: 0,
  //     left: 0,
  //     behavior: 'instant',
  //   });
  // }, [location]);
  return (
    <div style={{ backgroundColor: '#D9F3FD' }}>
      <Header {...props} navWrapperColor="#83BD41" signInButtonColor="#00aeef" signUpButtonColor="#EC5624" />
      <OpportunitiesList />
      <Divider
        sx={{
          borderStyle: 'dashed',
          width: '90%',
          borderColor: '#00AEEF',
          margin: '20px auto',
        }}
      />
      <Partners {...props} />
    </div>
  );
};

export default OpportunititesInterships;
